import React from 'react';
import s from './s.module.less';
import klarityLogo from 'assets/logo/klarity.png';
import { isProductionEnv } from 'utils/common';
import { VITE_ZOOM_SDK_KEY_DEV, VITE_ZOOM_SDK_KEY } from 'constants/common';
import ZoomVideoView from './components/ZoomVideoView';
import { Button } from 'antd';
import { EMeetingUserType, EZoomVideoViewActionType, TServerRoomInfo, TZoomVideoViewProps } from 'types/zoom';
import SendReminderModal from 'components/SendReminderModal';
import FollowUpModal from 'components/FollowUpModal';
import { Prospect } from 'types/common';
import ParticipantsDrawer from 'components/ParticipantsDrawer';

type IProp = TZoomVideoViewProps & {
    showLogo?: boolean;
    autoShowVideo?: boolean;
    serverMeetingInfo?: TServerRoomInfo;
    client?: Prospect;
    onMeetingInfoUpdated: () => void;
};

const ProviderZoomCallView = (props: IProp) => {
    const {
        videoWidth,
        videoHeight,
        showLogo,
        autoShowVideo = true,
        client,
        serverMeetingInfo,
        onAction,
        mode = 'preview',
        videoDefaultOn = false,
        audioDefaultOn = false,
        sessionKey,
        token,
        userName,
        onMeetingInfoUpdated,
        endFlag,
        newCommingMessage,
        newCommingMessageAmount,
        layout,
        ratio,
        startFlag,
    } = props;
    const [zoomSDKKey, setZoomSDKKey] = React.useState<string | undefined>();
    const [showVideo, setShowVideo] = React.useState<boolean>(autoShowVideo);
    const [showParticipantsDrawer, setShowParticipantsDrawer] = React.useState<boolean>(false);
    const [showSendReminderModal, setShowSendReminderModal] = React.useState<boolean>(false);
    const [showScheduleFollowUpModal, setShowScheduleFollowUpModal] = React.useState<boolean>(false);
    const appointmentDetail = serverMeetingInfo?.appointmentDetail;
    React.useEffect(() => {
        if (isProductionEnv()) {
            setZoomSDKKey(VITE_ZOOM_SDK_KEY);
        } else {
            setZoomSDKKey(VITE_ZOOM_SDK_KEY_DEV);
        }
    }, []);

    const onActionZoomCallAction = (actionType: EZoomVideoViewActionType) => {
        if (actionType === EZoomVideoViewActionType.SEND_A_REMINDER) {
            setShowSendReminderModal(true);
            return;
        }
        if (actionType === EZoomVideoViewActionType.SCHEDULE_FOLLOW_UP) {
            setShowScheduleFollowUpModal(true);
            return;
        }
        if (actionType === EZoomVideoViewActionType.PARTICIPANTS) {
            setShowParticipantsDrawer(true);
            return;
        }
        onAction?.(actionType);
    };

    return (
        <div className={s.videoOutWrap}>
            {showLogo && <img src={klarityLogo} alt="logo" className={s.logo} />}
            <div className={s.videoWrap}>
                {showVideo && (
                    <ZoomVideoView
                        userName={userName}
                        mode={mode}
                        videoWidth={videoWidth}
                        videoHeight={videoHeight}
                        videoDefaultOn={videoDefaultOn}
                        audioDefaultOn={audioDefaultOn}
                        onAction={onActionZoomCallAction}
                        sessionKey={sessionKey}
                        token={token}
                        layout={layout}
                        role={EMeetingUserType.PROVIDER}
                        endFlag={endFlag}
                        newCommingMessage={newCommingMessage}
                        newCommingMessageAmount={newCommingMessageAmount}
                        ratio={ratio}
                        startFlag={startFlag}
                    />
                )}
            </div>
            {!showVideo && <Button onClick={() => setShowVideo(true)}>Show Video</Button>}
            <SendReminderModal
                open={showSendReminderModal}
                onCancel={() => setShowSendReminderModal(false)}
                onConfirm={() => setShowSendReminderModal(false)}
            />
            {appointmentDetail && client && (
                <FollowUpModal
                    open={showScheduleFollowUpModal}
                    onCancel={() => setShowScheduleFollowUpModal(false)}
                    onConfirm={() => setShowScheduleFollowUpModal(false)}
                    appointmentEventDetail={appointmentDetail!}
                    targetClient={client}
                />
            )}
            <ParticipantsDrawer
                open={showParticipantsDrawer}
                onCancel={() => setShowParticipantsDrawer(false)}
                onConfirm={() => setShowParticipantsDrawer(false)}
                meetingInfo={serverMeetingInfo}
                role={serverMeetingInfo?.currentUserType}
                onMeetingInfoUpdated={onMeetingInfoUpdated}
            />
        </div>
    );
};

export default ProviderZoomCallView;
